import { Card, styled } from '../../base';

export const StyledCandidatesPageWrap = styled('div')<{
    isEntityPath: boolean;
}>(({ isEntityPath }) => ({
    display: isEntityPath ? 'none' : 'inherit',
    padding: '16px',
}));

export const StyledTableContainer = styled(Card)(({ theme }) => ({
    padding: theme.spacing(1),
}));
